export default __webpack_public_path__ + "311ac3c3ce24f203714404e3b821ca64.svg";